module.exports = __webpack_public_path__ + "sv.svg?a855cffa55f7df61000f0ee5c27503fc";